import React,{useState, useCallback} from "react";
import Modal from "react-modal";
import { useAPI } from "../../hooks/contextApis";
import api from "../../services/api/index";
import { writeStorage } from "../../utils/storage/storage";
import check from "../../components/Toast/Image/check.svg";
import error from "../../components/Toast/Image/error.svg";
import { useProgress } from "../../hooks/progress";
import Loader from "./Loader";
import Toast from "../../components/Toast/ToastGG";

import {
    Container,
    Close,
    TitleBlack,
    SubTitleLogin,
    ButtonContainerTop,
    ButtonDelete,
    ButtonOK,
    GridTitle
  } from './styles';

import ButtonX from "../Images/ButtonX.svg"
interface ModalProps {
  isOpen: boolean;
  onRequestClose: () => void;
}

export default function ModalLogin( { isOpen, onRequestClose }: ModalProps ) {
  const { chaveSessao, emailSessao } = useAPI(); 

  const [isClose] = useState(false);
  const [list, setList] = useState<any>([]);
  const { isLoad, setLoad } = useProgress();
  const handleExit = useCallback(() => {
        onRequestClose();
  },[onRequestClose]);


  let toastProperties: {
    id: number;
    title: string;
    description: string;
    backgroundColor: string;
    icon: any;
  } | null = null;
  //eslint-disable-next-line
  const showToast = (type: any) => {
    const id = Math.floor(Math.random() * 101 + 1);

    switch (type) {
      case "success":
        toastProperties = {
          id,
          title: "",
          description: "Login efetuado com sucesso",
          backgroundColor: "#5cb85c",
          icon: check,
        };
        break;
      case "primeiro":
        toastProperties = {
          id,
          title: "",
          description: "Primeiro acesso?",
          backgroundColor: "#f0ad4e",
          icon: check,
        };
        break;
      case "warning":
        toastProperties = {
          id,
          title: "",
          description: "Erro ao efetuar login",
          backgroundColor: "#f0ad4e",
          icon: error,
        };
        break;
      case "email":
        toastProperties = {
          id,
          title: "",
          description: "Usuário inexistente",
          backgroundColor: "#f0ad4e",
          icon: error,
        };
        break;
      case "senhaErrada":
        toastProperties = {
          id,
          title: "",
          description: "Senha incorreta",
          backgroundColor: "#f0ad4e",
          icon: error,
        };
        break;
      case "cadastre":
        toastProperties = {
          id,
          title: "",
          description: "Cadastre sua senha...",
          backgroundColor: "#f0ad4e",
          icon: check,
        };
        break;
      case "semEquipe":
        toastProperties = {
          id,
          title: "",
          description: "Coordenador sem equipe vinculada",
          backgroundColor: "#f0ad4e",
          icon: error,
        };
        break;
      case "redirect":
        toastProperties = {
          id,
          title: "",
          description: "Redirecionando...",
          backgroundColor: "#f0ad4e",
          icon: check,
        };
        break;
      case "404":
        toastProperties = {
          id,
          title: "",
          description: "Sem propostas encontradas",
          backgroundColor: "#f0ad4e",
          icon: error,
        };
        break;
      case "403":
        toastProperties = {
          id,
          title: "",
          description: "Acesso não autorizado",
          backgroundColor: "#f0ad4e",
          icon: error,
        };
        break;
      case "inativo":
        toastProperties = {
          id,
          title: "",
          description: "Login não autorizado",
          backgroundColor: "#f0ad4e",
          icon: error,
        };
        break;
      default:
        setList([]);
    }
    setList([...list, toastProperties]);
  };

    const setDadosLogin = useCallback(
      async ({ id }) => {
        api.defaults.headers.common = {
          Authorization: `bearer ${sessionStorage.getItem("@ARP-Energia:token")}`,
        };
        setLoad(true);
        await api.get(`/csp/representante/cards/consultar?idCard=${id}`)
          .then((res) => {
            const removeItem = (arr: any, refId: any) => {
              return arr.filter(function (i: any) {
                return i.situa_o_arp !== refId;
              });
            };
            const arr = removeItem(res.data["cards"], "inativo");
            if (res.status === 200) {
              setLoad(false);
              writeStorage({
                key: "dados",
                object: {
                  Cards: arr,
                },
              });
  
              showToast("success");
              setTimeout(function () {
                showToast("redirect");
              }, 1000);
  
              setTimeout(function () {
                setLoad(false);
                window.location.href = "/arp/";
              }, 3000);
            }
          })
          .catch((error) => {
            setLoad(false);
            if (error.response.status === 403) {
              //showToast('403')
              setLoad(false);
            }
            if (error.response.status === 404) {
              const arr = error.response.data["cards"];
  
              writeStorage({
                key: "dados",
                object: {
                  Cards: arr,
                },
              });
  
              showToast("success");
              setTimeout(function () {
                showToast("redirect");
              }, 1000);
  
              setTimeout(function () {
                setLoad(false);
                window.location.href = "/arp/";
              }, 3000);
            }
            if (error.response.status === 500) {
              //showToast('500')
              setLoad(false);
            }
          });
      },
      [setLoad, showToast]
    );

  const handleProsseguir = useCallback(async () => {
    
    try {
      const payload = {
        email: emailSessao,
        chaveValidadeSessao: chaveSessao,
      };

      const res = await api.post( "/csp/representante/sessao/derrubar",payload );
          if (res.data["retorno"] === "OK") {
            const token = res.data.acessToken;
            sessionStorage.setItem("@ARP-Energia:token", token);

            writeStorage({
              key: "login",
              object: {
                NomeRepresentante: res.data.informacao["nome"],
                EmailRepresentante: res.data.informacao["e_mail"],
                CpfRepresentante: res.data.informacao["cpf"],
                RazaoRepresentante: res.data.informacao["raz_o_social"],
                CnpjRepresentante: res.data.informacao["cnpj"],
                TipoVendedor: res.data.informacao["tipo"],
                CodigoLink:
                  res.data.informacao["c_digo_do_link_verificar_com_a_bplus"],
                canal: res.data.informacao["canal"],
                Meta: res.data.informacao["meta_do_m_s_1"],
                Grupo: res.data.informacao["grupo"],
                Gestor1: res.data.informacao["gerente_respons_vel"],
                Gestor2:
                  res.data.informacao["executivo_supervisor_respons_vel"],
                Gestor3: res.data.informacao["gestor_3"],
                Origem: res.data.informacao["origem"],
                CodigoPlano: res.data.informacao["plano_que_est_vendendo"],
                Equipe: res.data.informacao["equipe_1"],
                Regional: res.data.informacao["regional"],
                IdCard: res.data.informacao["idCard"],
              },
            });

            setDadosLogin({ id: res.data.informacao["idCard"] });
          }
    } catch (error) {
      console.error(error);
    }
  }, [onRequestClose]);

  return (
    <>
  <Toast toastList={list} autoDelete={true} />
    <Modal
      isOpen={isOpen}
      onRequestClose={() => {
        if (isClose===true) {
          onRequestClose();
        }
      }}
      contentLabel="Modal"
      ariaHideApp={false}
      className={{
        base: "modal-base-delete",
        afterOpen: "",
        beforeClose: "modal-base_before-close"
      }}
      overlayClassName={{
        base: "overlay-base",
        afterOpen: "overlay-base_after-open",
        beforeClose: "overlay-base_before-close"
      }}
      shouldCloseOnOverlayClick={true}
    >

      <Container>
        <GridTitle>
            <TitleBlack>Alerta</TitleBlack>
            <Close onClick={handleExit}>
                    <img 
                    alt={""} 
                    src={ButtonX}
                    width={15}
                    height={15}
                    >
                    </img>
                </Close>
        </GridTitle>
        <br/>
          <SubTitleLogin >Sessões ativas detectadas em outro dispositivo. Para atender às
                    políticas de segurança, ao prosseguir, você será desconectado
                    automaticamente dos outros dispositivos. </SubTitleLogin>
          <br/><br/>
          <ButtonContainerTop>
          
          <ButtonDelete onClick={() => handleExit()} >Cancelar</ButtonDelete>
          <ButtonOK onClick={handleProsseguir} disabled={isLoad}>
              {isLoad ? <Loader /> : "Prosseguir"}
            </ButtonOK>
        </ButtonContainerTop>

        </Container>

    </Modal>
    </>
  )
  }